import { render, staticRenderFns } from "./LastestTaskTable.vue?vue&type=template&id=5ca7af38&scoped=true&"
import script from "./LastestTaskTable.vue?vue&type=script&lang=js&"
export * from "./LastestTaskTable.vue?vue&type=script&lang=js&"
import style0 from "./LastestTaskTable.vue?vue&type=style&index=0&id=5ca7af38&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca7af38",
  null
  
)

export default component.exports